jQuery(document).ready(function($){

    // Init standalone layout-1 CE's.
    $('.frame-slideshow .ce-gallery').each(function() {
        $(this).wrap('<div class="ep-slideshow-outer" />');

        $(this).slick({
            autoplay: true,
            adaptiveHeight: false,
            autoplaySpeed: 6000,
            fade: true,
           // dots: true,
            waitForAnimate: false,
            pauseOnHover: false,
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 992,
                settings: {
                    pauseOnHover: true,
                    fade: false,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },{
                breakpoint: 768,
                settings: {
                    pauseOnHover: true,
                    fade: false,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },{
                breakpoint: 480,
                settings: {
                    autoplay: false,
                    fade: false,
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
        var playpause_text = 'Pause';
        if ($(this).slick('slickGetOption', 'autoplay') == false) {
            $(this).addClass('ep-slick-paused');
            playpause_text = 'Play';
        }

    // $(this).parent().append('<button type="button" class="slick-pause ep-slick-playpause">' + playpause_text + '</button>');

    });

    // Init slideshows not already initialized.
/*    $('.ep-slideshow').not('.slick-initialized').each(function() {
        $(this).wrap('<div class="ep-slideshow-outer EXTRA" />');

        $(this).slick({
            autoplay: true,
            adaptiveHeight: false,
            autoplaySpeed: 6000,
            fade: true,
           // dots: true,
            waitForAnimate: false,
            pauseOnHover: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    pauseOnHover: true,
                    fade: false,
                    centerMode: false,
                    slidesToShow: 1
                }
            },{
                breakpoint: 480,
                settings: {
                    autoplay: false,
                    arrows: false,
                    centerMode: false,
                    slidesToShow: 1
                }
            }]
        });
        var playpause_text = 'Pause';
        if ($(this).slick('slickGetOption', 'autoplay') == false) {
            $(this).addClass('ep-slick-paused');
            playpause_text = 'Play';
        }

       // $(this).parent().append('<button type="button" class="slick-pause ep-slick-playpause">' + playpause_text + '</button>');

    });
    */
    // @todo:
    $('.ep-slick-playpause').click(function(){
        var $slickObj = $(this).parent().children('.ep-slideshow');
        if ($slickObj.hasClass('ep-slick-paused')) {
            $slickObj.slick('slickPlay').slick('slickNext').removeClass('ep-slick-paused');
            $(this).text('Pause');
        } else {
            $slickObj.slick('slickPause').addClass('ep-slick-paused');
            $(this).text('Play');
        }
    });

    /*
    $('a.tta-lightbox').magnificPopup({
        type:'image',
        gallery: {
            enabled: true
        },
        image: {
            titleSrc: 'title'
        }
    });
    */
    /*
    $('a.lightbox').magnificPopup({
        type:'image',
        gallery: {
            enabled: true
        },
        image: {
            titleSrc: function(item) {
                return $(item.el).parent().children('figcaption').text();
            }
        }
    });
    */

    /* slick-lightbox disabled pending resolution of Safari issues. */
    /*
    // Also handle lightbox.
    var slickLightboxOpts = {
        waitForAnimate: false,
        itemSelector: 'a.lightbox',
        useHistoryApi: true,
        caption: function(element) { return $(element).parent().children('figcaption').text(); }
    };

    // set class that prevents scrolling on body.
    var slickLightboxEvents = {
        'show.slickLightbox': function() { 
            // $('.ep-slideshow .ce-gallery').slickPause();
            $('body').addClass('ep-slick-lightbox-show');
        },
        'hide.slickLightbox': function() {
            //@todo don't resume if it was paused before...use .ep-slick-paused above @todo...
            //$('.ep-slideshow .ce-gallery').slickPlay();
            $('body').removeClass('ep-slick-lightbox-show');
        }
    };

    // Register with normal ce-gallery
   // $('.ep-gallery').slickLightbox(slickLightboxOpts).on(slickLightboxEvents);
    $('body').slickLightbox(slickLightboxOpts).on(slickLightboxEvents);

    // Register with news media
   // $('.news-img-wrap').slickLightbox(slickLightboxOpts).on(slickLightboxEvents);
    */


});
